import PageContext from "global_state/context/PageContext"
import { useEffect, useState } from "react"
import { useContext } from "react"
import { BiHide, BiShow } from "react-icons/bi"

import FormSCSS from 'assets/scss/Form.module.scss'
import AppSCSS from 'assets/scss/App.module.scss'
import { PageType } from "types/PageI"
import { ResetPasswordService } from "services/user_services/ResetPasswordService"
import Loader from "components/Loader"

import content from 'languages/ResetPassword.json'
import Title from "components/Title"


function ResetPassword() {
    const [loading, setLoading] = useState(false)
    const {page, dispatchPage}  = useContext(PageContext)
    const [password, setNewUserPassword] = useState('')
    const [password_visibility, setPasswordVisibility] = useState(false)
    let language = page.settings.language
    const [set_passowrd_response, setResponse] = useState<any>()

    const isPasswordStrongEnought = (password: string): boolean => {
        if (password.length < 8) {
            dispatchPage({
                type: "add_notification",
                payload: {
                    notification: {
                        type: "error",
                        message: "weak_password"
                    }
                }
            }) 
            return false
        }
        return true
    }
    const handleSubmit = async (event) => {
        event.preventDefault()
        // console.log(password);
        // setLoading(true)
        
        if (!isPasswordStrongEnought(password)) {
            return 
        }
        
        setResponse(await ResetPasswordService(password))
    }

    useEffect(() => {
        setLoading(false)

        if (set_passowrd_response === "item_password_required") {
            dispatchPage({
                type: "add_notification",
                payload: {
                    notification: {
                        type: "error",
                        message: set_passowrd_response
                    }
                }
            })
            return 
        }       

        if ((typeof set_passowrd_response === 'string') && set_passowrd_response.includes("error")) {
            dispatchPage({
                type: "add_notification",
                payload: {
                    notification: {
                        type: "error",
                        message: set_passowrd_response
                    }
                }
            })
            return 
        }

        if(set_passowrd_response == "password_set"){
            window.history.pushState("", "",window.location.href.split('?')[0]);
            dispatchPage({type: "render", payload: {page: PageType.log_in_form}})
        }
    }, [set_passowrd_response])
    
    if (loading) {
        return (
            <Loader/>
        )
    }

    return (
        <div className={[FormSCSS.form_wrapper].join(" ")}>
            <Title back_arrow={false} title={content[language].title}/>

            <form 
                className={[FormSCSS.form].join(" ")}
                onSubmit={(event) => {handleSubmit(event)}}>
                
                <div>{content[language].text}</div>
                
                <label 
                    className={FormSCSS.label}
                    htmlFor="password">
                    <input 
                        className={FormSCSS.input}
                        type={(password_visibility) ? "text" : "password"} 
                        name="password" 
                        id="password" 
                        placeholder={content[language].input_user_password_placeholder} 
                        value={password}
                        onChange={(e) => {setNewUserPassword(e.target.value)}}/>
                    <div 
                        onClick={() => setPasswordVisibility(!password_visibility)} 
                        className={FormSCSS.password_visibility}>
                        {(password_visibility) ? 
                            <BiShow/> : <BiHide/>}
                    </div>
                </label>

                <button 
                    className={[AppSCSS.button, AppSCSS.red].join(" ")}
                    type="submit">
                    {content[language].button_submit}
                </button>
            </form>
        </div>
    )
}

export default ResetPassword